import { ReportType } from '@app/domain/model/report-type';
import { TransactionReportRecord } from './transaction-report-record';
import Big from 'big.js';

export class TransactionReport {

  readonly amount: Big;

  readonly elements: TransactionReportRecord;

  readonly lbsPurchased: number;

  readonly piecesPurchased: number;

  readonly purchaseType: ReportType;

  readonly reportsNumber: number;

  /**
   * Converts JSON representation of name into {@link TransactionReport} instance.
   *
   * @param jsonObject JSON representation of transaction report
   */
  static fromJSON(jsonObject: any): TransactionReport {
    const result = Object.create(TransactionReport.prototype);
    return Object.assign(result, jsonObject, {
      elements: jsonObject.elements ? (jsonObject.elements as any[]).map(element => TransactionReportRecord.fromJSON(element)) : null,
      purchaseType: jsonObject.purchaseType ? ReportType.fromString(jsonObject.purchaseType) : null,
    });
  }

}
